export const NSD_STATIC_URL = 'https://nsdstaticasset.blob.core.windows.net';